import { useMediaQuery, useTheme } from "@mui/material";

export type UseCssMediaQuery = ReturnType<typeof useCssMediaQuery>;

export function useCssMediaQuery(
  direction: "up" | "down" | "between" | "only"
) {
  const theme = useTheme();
  const config = {
    noSsr: true,
  };

  let queries = {
    between: {
      xs: useMediaQuery(theme.breakpoints.down("xs"), config),
      sm: useMediaQuery(theme.breakpoints.between("xs", "sm"), config),
      md: useMediaQuery(theme.breakpoints.between("sm", "md"), config),
      lg: useMediaQuery(theme.breakpoints.between("md", "lg"), config),
      xl: useMediaQuery(theme.breakpoints.between("lg", "xl"), config),
    },
    only: {
      xs: useMediaQuery(theme.breakpoints.only("xs"), config),
      sm: useMediaQuery(theme.breakpoints.only("sm"), config),
      md: useMediaQuery(theme.breakpoints.only("md"), config),
      lg: useMediaQuery(theme.breakpoints.only("lg"), config),
      xl: useMediaQuery(theme.breakpoints.only("xl"), config),
    },
    up: {
      xs: useMediaQuery(theme.breakpoints.up("xs")),
      sm: useMediaQuery(theme.breakpoints.up("sm")),
      md: useMediaQuery(theme.breakpoints.up("md")),
      lg: useMediaQuery(theme.breakpoints.up("lg")),
      xl: useMediaQuery(theme.breakpoints.up("xl")),
    },
    down: {
      xs: useMediaQuery(theme.breakpoints.down("xs")),
      sm: useMediaQuery(theme.breakpoints.down("sm")),
      md: useMediaQuery(theme.breakpoints.down("md")),
      lg: useMediaQuery(theme.breakpoints.down("lg")),
      xl: useMediaQuery(theme.breakpoints.down("xl")),
    },
  };
  return queries[direction];
}
